import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { StudioManager } from '../services/studio.manager';
import { SessionFactory } from '../caches/session.factory';

@Injectable()
export class DatabasesResolver implements Resolve<any> {
    sessionFactory: SessionFactory;
    constructor(private studioManager: StudioManager) {
        this.sessionFactory = SessionFactory.getInstance();
    }

    resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot) {
        if (this.sessionFactory.fldr.fldr_Id == -1) {
            this.sessionFactory.fldr.fldr_Id = route.params["fldr_Id"];
        }

        return this.studioManager.getDatabases();
    }
}
